import "./AuditTrail.css";

export type AuditTrailEntry = {
  id: string;
  actionType: string;
  performedBy: string;
  performedAt: string;
  details?: Record<string, unknown> | null;
};

type AuditTrailProps = {
  entries: AuditTrailEntry[];
};

const ACTION_LABELS: Record<string, string> = {
  order_failed: "Ordre fejlet",
  item_edited: "Vare redigeret",
  auto_fix_applied: "Auto-rettelse anvendt",
  resend_attempted: "Gensendelse forsøgt",
  resend_succeeded: "Gensendelse lykkedes",
  resend_failed: "Gensendelse fejlet",
};

const ACTION_ICONS: Record<string, string> = {
  order_failed: "❌",
  item_edited: "✏️",
  auto_fix_applied: "🔧",
  resend_attempted: "🔄",
  resend_succeeded: "✅",
  resend_failed: "⚠️",
};

const formatTimestamp = (iso: string): string => {
  const date = new Date(iso);
  if (isNaN(date.getTime())) return iso;
  return date.toLocaleString("da-DK", {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

export const AuditTrail = ({ entries }: AuditTrailProps) => {
  if (entries.length === 0) {
    return (
      <div className="AuditTrail AuditTrail--empty">
        <p className="AuditTrail__empty-text">Ingen handlinger registreret</p>
      </div>
    );
  }

  return (
    <div className="AuditTrail">
      <div className="AuditTrail__list">
        {entries.map((entry) => (
          <div key={entry.id} className="AuditTrail__entry">
            <div className="AuditTrail__entry-line" />
            <div className="AuditTrail__entry-icon">
              {ACTION_ICONS[entry.actionType] || "📋"}
            </div>
            <div className="AuditTrail__entry-content">
              <div className="AuditTrail__entry-header">
                <span className="AuditTrail__entry-action">
                  {ACTION_LABELS[entry.actionType] || entry.actionType}
                </span>
                <span className="AuditTrail__entry-time">
                  {formatTimestamp(entry.performedAt)}
                </span>
              </div>
              <div className="AuditTrail__entry-performer">
                {entry.performedBy}
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
